"use client";

import EMPTY_IMAGE from "@assets/image/empty_image.png";
import { useProgressRouter } from "@lib/util/navigation";
import ButtonCustom from "@modules/layout/components/button-custom";
import Image from "next/image";

type Props = {
  message?: string;
};

function Empty({ message }: Props) {
  const router = useProgressRouter();

  const handleClick = () => {
    const pathname = window.location.pathname;

    const shouldProductSeacrh = pathname.includes("/product-search");
    if (shouldProductSeacrh) {
      router.replace("/store");
    } else {
      router.replace(pathname);
    }
  };
  return (
    <div className="flex flex-col justify-center items-center gap-2">
      <Image src={EMPTY_IMAGE} alt="" />
      <div className="text-gray-400">{message || "Không tìm thấy sản phẩm"}</div>
      <div>
        <ButtonCustom children="Xoá bộ lọc" onClick={handleClick} />
      </div>
    </div>
  );
}

export default Empty;
